import Script from "next/script";
import React, { FC, useEffect } from "react";

import Breadcrumbs from "../common/Breadcrumbs";
import Footer from "../common/footer";

const plataformName = `${process.env.NEXT_PUBLIC_PLATAFORM_NAME}`;

declare const OneTrust: any;

interface PrivacyPolicyProps {
  idNotice: string;
  title?: string;
  links?: any;
  termUse?: boolean;
}

const PrivacyPolicyComponents: FC<PrivacyPolicyProps> = props => {
  const loadOneTrust = () => {
    if (typeof OneTrust !== "undefined") {
      OneTrust?.NoticeApi?.Initialized.then(function () {
        props.termUse
          ? OneTrust.NoticeApi.LoadNotices(
              [process.env.NEXT_PUBLIC_PRIVACY_SRC_ONE_TRUST + "draft/" + props.idNotice + ".json"],
              false,
            )
          : OneTrust.NoticeApi.LoadNotices([
              process.env.NEXT_PUBLIC_PRIVACY_SRC_ONE_TRUST + props.idNotice + ".json",
            ]);
      });
    }
  };

  useEffect(() => {
    loadOneTrust();
  }, []);

  return (
    <main className="privacy">
      <header className="banner flex flex-col justify-center">
        <span className="text-[36px] ml-40 font-dmSans font-medium">
          <span className="text-afya-aqua-200">Afya</span>{" "}
          <span className="lowercase"> {plataformName} </span>
        </span>
      </header>
      {props.links ? (
        <div className="flex justify-start ml-40 mt-6">
          <Breadcrumbs links={props.links} />
        </div>
      ) : (
        <></>
      )}
      <h1 className="text-[36px] text-[black] font-nunito font-semibold text-left mt-6 ml-40">
        {props.title}
      </h1>

      <div id={"otnotice-" + props.idNotice} className="mx-40 mt-[5vh] privacy-body"></div>

      <Script
        src={process.env.NEXT_PUBLIC_PRIVACY_SRC}
        type="text/javascript"
        charSet="UTF-8"
        id={process.env.NEXT_PUBLIC_PRIVACY_ID}
        onLoad={loadOneTrust}
        dangerouslySetInnerHTML={{
          __html: `atob(${props.termUse ? "" : process.env.NEXT_PUBLIC_PRIVACY_SETTINGS})`,
        }}
      />
      <div className="ml-36">
        <Footer />
      </div>
    </main>
  );
};

export default PrivacyPolicyComponents;
